module.exports = __webpack_public_path__ + "img/zhu_xc10.243c7f1b.jpg";